import React from 'react';

import './App.css';
import HomePage from "./pages/homePage/homePage";
import FirebaseLogout from './components/firebaseLogout/firebaseLogout';


import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";

import config from "./config"
import TutorialPage from './pages/tutorialPage/tutorialPage';
import Portal from './pages/portal/portal';
import UpgradeRequestPage from './pages/upgradeRequestPage/upgradeRequestPage';
import SubscriptionRouter from './routers/subscriptionRouter/subscriptionRouter';
import PrivacyPolicyPage from './pages/privacyPolicyPage/privacyPolicyPage';
import SignInRouter from './pages/signInRouter/signInRouter';
import LoginSuccessPage from './pages/loginSuccessPage/loginSuccessPage';

const stripePromise = loadStripe(config.stripeKey);

function App() {
    return (
        <div className="app">
            <Elements stripe={stripePromise}>
                    <Router>
                        <Switch>
                            <Route exact path="/">
                                <HomePage />
                            </Route>
                            <Route exact path="/logout">
                                <FirebaseLogout />
                            </Route>

                            <Route exact path="/tutorial">
                                <TutorialPage />
                            </Route>

                            <Route exact path="/privacy">
                                <PrivacyPolicyPage />
                            </Route>

                            <Route 
                                path="/upgrade" 
                                render={({ match: { url } }) => (
                                <>
                                    <UpgradeRequestPage stripePromise={stripePromise} url={url} />
                                </>
                            )} />

                            <Route
                                path="/subscription"
                                render={({ match: { url } }) => (
                                    <>
                                        <SubscriptionRouter url={url} />
                                    </>
                                )}
                            />

                            <Route
                                path="/login"
                                render={({ match: { url } }) => (
                                    <>
                                        <Switch >
                                            <Route exact path={`${url}/portal`}>
                                                <Redirect to={`/signin/initiate/oauth?method=google&redirect=portal`} />
                                            </Route>
                                            <Route exact path={`${url}/extension`}>
                                                <Redirect to={`/signin/initiate/oauth?method=google&redirect=extension`} />
                                            </Route>
                                            <Route exact path={`${url}/success`}>
                                                <LoginSuccessPage />
                                            </ Route>
                                            <Redirect from={`${url}*`} to={`${url}/extension`} />
                                        </Switch>
                                        
                                    </>
                                )}
                            />

                            <Route
                                path="/signin"
                                render={({ match: { url } }) => (
                                    <>
                                        <SignInRouter url={url} />
                                    </>
                                )}
                            />

                            <Route
                                path="/portal"
                                render={({ match: { url } }) => (
                                    <>
                                        <Portal url={url} />
                                    </>
                                )}
                            />
                            <Redirect from='*' to='/' />
                        </Switch>
                    </Router>
            </Elements>
        </div>
    );
}

export default App;
